import { createApiService } from "@/core/api/apiService";
import type {
  ConversationDto,
  ConversationWithClientDto,
  CreateConversationDto,
  UpdateConversationDto,
} from "../types/conversationTypes";

export function createConversationApiClient() {
  const api = createApiService("conversations");

  return {
    getList: async (params?: {
      businessId?: string;
      phoneNumberId?: string;
      clientId?: string;
    }): Promise<ConversationWithClientDto[]> => {
      const queryParams = new URLSearchParams();
      if (params?.businessId) queryParams.set("businessId", params.businessId);
      if (params?.phoneNumberId)
        queryParams.set("phoneNumberId", params.phoneNumberId);
      if (params?.clientId) queryParams.set("clientId", params.clientId);
      const query = queryParams.toString();
      return api.get<ConversationWithClientDto[]>(query ? `/?${query}` : "/");
    },

    getById: async (id: string): Promise<ConversationWithClientDto> => {
      return api.get<ConversationWithClientDto>(`/${id}`);
    },

    create: async (data: CreateConversationDto): Promise<ConversationDto> => {
      return api.post<ConversationDto>("", data);
    },

    update: async (
      id: string,
      data: UpdateConversationDto
    ): Promise<ConversationDto> => {
      return api.put<ConversationDto>(`/${id}`, data);
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },
  };
}

const conversationApiService = createConversationApiClient();
export { conversationApiService };
